import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import YouTubeSection from './components/YouTubeSection';
import AboutSection from './components/AboutSection';
import ArtistsSection from './components/ArtistsSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import BannerSection from './components/BannerSection';
import InquirySection from './components/InquirySection';

export default function HomePage() {
  useEffect(() => {
    // Page title & meta
    document.title = 'Ganga Cassette – India\'s Leading Music Production Company & YouTube Music Label';

    // JSON-LD for Home page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'page-jsonld';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Ganga Cassette – India\'s Leading Music Production Company',
      url: `${import.meta.env.VITE_SITE_URL || ''}/`,
      description: 'Ganga Cassette (Ganga Cassette) is India\'s #1 music production company and YouTube music label. 100M+ subscribers, 100B+ views, 50+ YouTube awards.',
      isPartOf: {
        '@type': 'WebSite',
        name: 'Ganga Cassette',
        url: import.meta.env.VITE_SITE_URL || '',
      },
      about: {
        '@type': 'MusicGroup',
        name: 'Ganga Cassette',
        foundingDate: '1992',
        founder: { '@type': 'Person', name: 'Manmohan Sharma' },
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: `${import.meta.env.VITE_SITE_URL || ''}/` },
        ],
      },
    });
    const existing = document.getElementById('page-jsonld');
    if (existing) existing.remove();
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('page-jsonld');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="bg-[#0d0d0d] min-h-screen">
      <Navbar />
      <main>
        <div className="mt-20">
        <BannerSection />
        </div>
        <HeroSection />
        <YouTubeSection />
        <AboutSection />
        <ServicesSection />
        <ArtistsSection />
        <TestimonialsSection />
        <CTASection />
        <div className="block lg:hidden px-4 pb-10">
      <div className="max-w-md mx-auto">
        <InquirySection />
      </div>
    </div>
      </main>
      <Footer />
    </div>
  );
}
